module.exports = __webpack_public_path__ + "static/media/7.436a4820.jpg";